export default __webpack_public_path__ + "static/media/5_2_logo.11145a42.png";